import { useState, useRef, useEffect } from "react";
import style from "./style.module.scss";
import Form from "../Form";
import { domain } from "config.js";


function EditProperty() {

    const [ref, setRef] = useState("");
    const [data, setData] = useState(null);
    const refInput = useRef();

    useEffect(() => {
        if (ref === "") return;

        fetch(domain + "/int-search", { method: "POST", body: JSON.stringify({ ref }) }).then(response => {
            response.json().then(json => {
                if (json.length === 0) return alert("No property found with the reference " + ref);
                setData(json[0]);
            });
        }).catch(e => console.log(e));
    }, [ref]);

    function findRef() {
        let value = refInput.current.value;

        if ((value.length < 5) || value.indexOf("-") < 0) return alert("Invalid reference");
        value = value[0].toUpperCase() + value.substring(1);

        setRef(value);
    }

    return <div className={style.EditProperty}>


        <div className={`row ${style.header} text-white ${style.header}`}>
            <div className={style.title}>
                <h1 className={style.titleHeader}>Edit properties</h1>
            </div>

            <div className={`${style.headerText}`}>
                <p >Here you can edit properties already in the database.</p>
                <p >You can enter reference number of a property, and get its parameters, which you can change freely.</p>
            </div>
        </div>


        <div className={style.content}>
            {(!data) && <div className={style.finder}>
                <h3>Enter Reference Number</h3>
                <div>
                    <input ref={refInput} onKeyDown={e => { if (e.key === "Enter") findRef(); }} />
                    <div className={style.button} onClick={findRef}>Find</div>
                </div>
            </div>}

            {data && <div className={style.formCnt}>
                <Form mode="edit" data={data} />
                <div className={"btn-sm btn-danger " + style.deleteButton} onClick={() => {
                    if (window.confirm("Warning!\n\nAre you sure you want to delete the " + ref + " property?\n\nThis is irreversible")) {
                        fetch(domain + "/int-deleteProperty", { method: "POST", body: JSON.stringify({ ref }) }).then(response => {
                            if (response.ok) {
                                response.json().then(json => {
                                    if (json.success) {
                                        alert("Property deleted successfully");
                                        setRef("");
                                        setData(null);
                                    }
                                })
                            } else {
                                alert("Error deleting property");
                            }
                        }).catch(e => console.log(e));
                    }
                }}>Delete Property</div>
                <br />
                <br />
                <div className={style.back} onClick={e => { setData(null); setRef("") }}>&lt; Back</div>
            </div>}
        </div>
    </div>
}

export default EditProperty;